export const fastApplyStatuses = {
  fastApplyApplied: "fast_apply_applied",
  fastApplyAssignmentsRequested: "fast_apply_assignments_requested"
};
